import { render, staticRenderFns } from "./combine.vue?vue&type=template&id=5e97f562"
import script from "./combine.vue?vue&type=script&lang=js"
export * from "./combine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports